if (!customElements.get('install-steps')) {
  class InstallSteps extends HTMLElement {
    constructor() {
      super();

      const sliderElement = this.querySelector('.swiper-slider');

      this.slider = new Swiper(sliderElement, {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 12,
        grabCursor: true,
        navigation: {
          nextEl: '.install-steps__arrow-next',
          prevEl: '.install-steps__arrow-prev'
        },
        pagination: {
          el: '.install-steps__progress-items',
          renderBullet: function (index, className) {
            return `
              <div class="install-steps__progress-item ${className}">
                ${index+1}
              </div>
            `;
          },
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
        }
      });
    }
  }

  customElements.define('install-steps', InstallSteps);
}